import { useRolesModalsContext } from 'modules/roles/contexts';
import { useNavigation } from 'modules/roles/hooks';
import styled from 'styled-components';
import { Add16 } from 'ui/icons/action/Add16';
import { FolderLine } from 'ui/icons/action/FolderLine';
import { LinkButton } from 'ui/linkButton';
import { PageHeader } from 'ui/pageHeader';
import { PrimaryButton, BUTTON_VARIANTS } from 'ui/button';
import { Body2, spacing } from 'ui/theme';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { pxToRem } from 'utils/convert';
import { RolesModals } from './RolesModals';
import { RolesTable } from './RolesTable';

const StyledBody = styled.div`
  max-width: ${pxToRem(480)};
  margin-bottom: ${spacing.plusHalf};
`;

const StyledLinkButton = styled(LinkButton)`
  display: inline-flex;
  gap: ${spacing.half};
`;

export const ROLES_PAGE_TEXT = {
  pageTitle: 'Roles',
  description:
    'Roles are bundles of permissions related to managing a project and its resources. They are granted to members for each project they belong to.',
  learnMoreText: 'Learn more in our docs',
  learnMoreUrl:
    'https://support.iterable.com/hc/en-us/articles/205480335-Account-Roles-and-Permissions',
};

const CreateRoleButton = ({ onClick }: { onClick: () => void }) => (
  <PrimaryButton onClick={onClick}>
    <Add16 />
    <span>New role</span>
  </PrimaryButton>
);

export const RolesPage = () => {
  const { showCreateRoleModal } = useRolesModalsContext();
  const { setCreated } = useNavigation();

  return (
    <FixedWidth id="roles-page-container">
      <PageHeader pageActions={<CreateRoleButton onClick={showCreateRoleModal} />}>
        {ROLES_PAGE_TEXT.pageTitle}
      </PageHeader>
      <StyledBody>
        <Body2>{ROLES_PAGE_TEXT.description}</Body2>
        <StyledLinkButton
          isAngular
          rel="noreferrer noopener"
          target="_blank"
          to={ROLES_PAGE_TEXT.learnMoreUrl}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          <FolderLine />
          {ROLES_PAGE_TEXT.learnMoreText}
        </StyledLinkButton>
      </StyledBody>
      <RolesTable />
      <RolesModals setCreated={setCreated} />
    </FixedWidth>
  );
};
